/**
 * Enum to manage session storage string keys, please use it
 */
export enum StorageKey {
    theme = 'THEME_PREFERENCE',
    httpCache = 'HTTP_CACHE',
    commonFilters = 'COMMON_FILTERS',
    usersAdvancedFilters = 'USERS_ADVANCED_FILTERS',
    professionalsAdvancedFilters = 'PROFESSIONALS_ADVANCED_FILTERS',
    productAdvancedFilters = 'PRODUCTS_ADVANCED_FILTERS',
    orderAdvancedFilters = 'ORDERS_ADVANCED_FILTERS',
    requestAdvancedFilters = 'REQUESTS_ADVANCED_FILTERS',
}
